import { Component, OnInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscribable, Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewChecked , OnDestroy{

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  

  userColl: any = [];
  usersecurityColl: any = [];

  loginform = new FormGroup({
    emailid: new FormControl('', Validators.required),
    userpwd: new FormControl('', Validators.required),
  });
  loginsecurityform = new FormGroup({
    securitykey: new FormControl('', Validators.required),

  });

  auth: string = "";
  _routerLoginSub = Subscription.EMPTY;

  constructor(private loginService: LoginDataService, private appService: DhukanDataService,private route: ActivatedRoute,
    private toastr: ToastrService, public router: Router) {
      
    this._routerLoginSub=  this.route.queryParams.subscribe(params => {
     
        if (params.auth !== undefined) {
          this.auth = params.auth


          if (this.auth !== '') {
            alert(this.auth)
            localStorage.setItem('bstoken', JSON.stringify(this.auth));
            localStorage.setItem('bstokenon', JSON.stringify(new Date()));
            this.loginService.fnGetUserRoleList();
            this.loginService.islogin = false;
            this.router.navigate(['/']).then(() => {
              window.location.reload();
            });
          }
        }
      });
     }

  ngOnInit() {
    this.fnInitializeLoginFormGroup();
    this.fnInitializeLoginSecurityFormGroup();

    //setTimeout(() => this.appService.islogin = false);
    this.loginService.islogin = false;
  }

  ngAfterViewChecked() {
    this.loginService.islogin = true;
  }


  ngOnDestroy(): void {
    if (this._routerLoginSub !== undefined) {
      this._routerLoginSub.unsubscribe();
    }
  }


  fnInitializeLoginFormGroup() {
    this.loginform.setValue({
      emailid: '',
      userpwd: ''
    })
  }
  fnInitializeLoginSecurityFormGroup() {
    this.loginsecurityform.setValue({
      securitykey: '',

    })
  }

  fnResetValidation() {

    if (this.loginform.get('emailid')) {    
      this.loginform.controls['emailid'].setErrors(null);
    }

  }

  fnLogin() {
    try {
      this.fnResetValidation();
      
      this.submitted = true;
      this.successfully = false;

      //Validate
      if (this.loginform.valid) {
        var data = {
          'emailid': this.loginform.get('emailid').value,
          'pwd': this.loginform.get('userpwd').value,
        }
        this.appService.getUserlogin(data)
          .subscribe(
            (res) => {

              if (res.json().status === 200) {

                this.userColl = res.json().result;

            
                if (this.userColl) {

                  if (this.userColl.length > 0) {

                    localStorage.setItem('bstoken', JSON.stringify(this.userColl[0].userid));
                    localStorage.setItem('bscmp',"");
                    localStorage.setItem('bstokenon', JSON.stringify(new Date()));
                    this.loginService.fnGetUserRoleList();
                    this.loginService.islogin = false;

                    if (this.userColl[0].isscreencheck === 1) {
                      var _screen = "";
                      // _screen=this.userColl[0].landingscreen;

                      // this.fnInsertActivityLog('LOGIN',this.userColl[0].loginuserid,this.userColl[0].username);

                      this.router.navigate(['/']).then(() => {
                        window.location.reload();
                      });

                    }
                  } else {
                    this.loginform.controls['emailid'].setErrors({ 'notfound': true });
                  }

                }

              }

            },
            (err) => {
              this.toastr.error('Error', err);
            })
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  fnLoginSecurity() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.loginsecurityform.valid) {
        var data = {
          'securitykey': this.loginsecurityform.get('securitykey').value,

        }
        this.appService.getLoginSecuritykey(data)
          .subscribe(
            (res) => {

              if (res.json().status === 200) {

                this.usersecurityColl = res.json().result;


                if (this.usersecurityColl) {

                  if (this.usersecurityColl.length > 0) {


                    localStorage.setItem('bstoken', JSON.stringify(this.usersecurityColl[0].userid));
                    this.loginService.fnGetUserRoleList();
                    this.loginService.islogin = false;



                    if (this.usersecurityColl[0].isscreencheck === 1) {
                      var _screen = "";
                      // _screen=this.userColl[0].landingscreen;

                      // this.fnInsertActivityLog('LOGIN',this.userColl[0].loginuserid,this.userColl[0].username);

                      this.router.navigate(['/Sales'])
                      this.loginService.fnGetUserRoleList()

                      // this.router.navigate(['/Sales']).then(() => {
                      //   window.location.reload();
                      // });

                    }
                  } else {
                    this.loginform.controls['username'].setErrors({ 'notfound': true });
                  }

                }

              }

            },
            (err) => {
              this.toastr.error('Error', err);
            })
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnSecurity(data) {
    var key = this.loginsecurityform.get('securitykey').value

    data = key + data

    this.loginsecurityform.patchValue({ 'securitykey': data })
  }
  fnClear() {
    let str = this.loginsecurityform.get('securitykey').value
    str = str.substring(0, str.length - 1);

    this.loginsecurityform.patchValue({ 'securitykey': str })
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: "LOGIN",
        refnum: refno,
        logdescr: desc,
        logby: refno,
      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
